export function googleMapsLink(location) {
  if (!location) {
    return null
  }

  return `https://maps.google.com/maps?daddr=${location.lat},${location.lng}&amp;ll=`
}

export function formatPrice(price, suffix = '') {
  if (typeof price !== 'number') {
    throw TypeError(`The price ${price} must be a number but was ${typeof price}`)
  }

  return [
    price.toLocaleString('nb-NO', {minimumFractionDigits: 2}),
    suffix,
  ].join('')
}

export function guleSiderMapLink(estate) {
  if (!estate || !estate.location || !estate.streetAddress) {
    return null
  }

  const {location, streetAddress, postalArea} = estate
  const zoom = 14;

  const query = encodeURIComponent(`${streetAddress}, ${postalArea || ''}`)
  return `https://kart.gulesider.no/?c=${location.lat},${location.lng}&z=${zoom}&q=${query}`
}

export function maps1881Link(estate) {
  if (!estate.streetAddress) {
    return null
  }

  const {streetAddress, postalArea} = estate
  
  const query = encodeURIComponent(`${streetAddress}, ${postalArea || ''}`)
  return `https://kart.1881.no/?query=${query}`
}
